module.exports = __webpack_public_path__ + "static/media/shape0_2.036cbb18.obj";